import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import componentBase from '../../../../../../src/lib/component-base';
import DelayGraph from './DelayGraph';
import WeatherConditions from './WeatherConditions';
import FSFlatButton from '../../../../../../src/components/lib/FSFlatButton';
import onResize from '../../../../../../src/lib/on-resize';
import { initialLoadFinish } from '../../../../redux/actions';

@onResize()
@componentBase('Sidebar')
export default class Sidebar extends React.Component {
  static propTypes = {
    airport: PropTypes.object,
    currentWeather: PropTypes.object,
    dispatch: PropTypes.func,
    delayIndex: PropTypes.object,
    initialLoad: PropTypes.bool,
  }

  componentDidMount() {
    this.initResizeListener();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.airport && this.props.airport && this.props.initialLoad) {
      this.props.dispatch(initialLoadFinish());
    }
  }

  componentWillUnmount() {
    this.removeResizeListener();
  }

  handleResize = () => {
    this.forceUpdate();
  }

  renderButtons() {
    const departureLabel = `Check ${this.props.airport.airportCode} Departures`;
    const departureLink = `/airports/departing-arriving/${this.props.airport.airportCode}/departures/`;
    const arrivalLabel = `Check ${this.props.airport.airportCode} Arrivals`;
    const arrivalLink = `/airports/departing-arriving/${this.props.airport.airportCode}/arrivals/`;
    const conditionsLink = `/airport-conditions/${this.props.airport.airportCode}`;
    const conditionsLabel = `Check ${this.props.airport.airportCode} Conditions`;

    const labelStyle = {
      fontSize: '14px',
      padding: '1px',
    };

    return (
      <div className='sidebar-button-container row'>
        <div className='col-sm-12 col-xs-12 col-lg-4 left-button-spacer'>
          <FSFlatButton
            className='sidebar-button button-left-departure'
            label={departureLabel}
            containerElement={<Link to={departureLink} />}
            labelStyle={labelStyle}
          />
        </div>
        <div className='col-sm-12 col-xs-12 col-lg-4 center-button-spacer'>
          <FSFlatButton
            className='sidebar-button button-center-arrivals'
            label={arrivalLabel}
            containerElement={<Link to={arrivalLink} />}
            labelStyle={labelStyle}
          />
        </div>
        <div className='col-sm-12 col-xs-12 col-lg-4 right-button-spacer'>
          <FSFlatButton
            className='sidebar-button button-right-conditions'
            label={conditionsLabel}
            containerElement={<Link to={conditionsLink} />}
            labelStyle={labelStyle}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.props.initialLoad) {
      // show spinner instead of 'choose an airport'
      return (
        <div />
      );
    }
    if (this.props.airport && !this.props.initialLoad) {
      return (
        <div className='row sidebar'>
          <div className='sidebar-header'>
            <div className='sidebar-airport-name'>
              <h3>{this.props.airport.airportCode ? `(${this.props.airport.airportCode})` : ''} {this.props.airport.airportName} </h3>
            </div>
            <div className='sidebar-airport-address'>
              <h4>
                {
                  `
                    ${this.props.airport.addressLine1 || ''}
                    ${this.props.airport.addressLine2 || ''}
                  `
                }
              </h4>
            </div>
          </div>
          <p className='condition-title' style={{ fontSize: '18pt' }}>Current Delay Status </p>
          <DelayGraph delayIndex={this.props.delayIndex} />
          <p className='condition-title' style={{ fontSize: '18pt' }}>Current Weather Conditions </p>
          <WeatherConditions currentWeather={this.props.currentWeather} />
          {this.renderButtons(this.mediaBreakpoint)}
        </div>
      );
    }
    if (!this.props.airport) {
      return <p>choose an airport</p>;
    }
    return (
      <div />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/AirportDelayMap/components/children/AirportDelayMap/children/Sidebar.js